// angular
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
// import { HashLocationStrategy, LocationStrategy } from '@angular/common';
// 3rd party
import {ToasterModule} from 'angular2-toaster';
import {AgmCoreModule} from '@agm/core';
import {NgApexchartsModule} from 'ng-apexcharts';
// application
import {ApiModule} from './api/api.module';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {
    APP_CONFIG,
    APP_CONFIG_AGGREGATION_COLORS,
    APP_CONFIG_AGGREGATION_COLORS_CONSOLIDATED,
    APP_CONFIG_QUANTITY_COLORS,
    APP_CONFIG_TOKEN
} from './app.config';
import {CommonsModule} from './commons/commons.module';
import {I18nModule} from './i18n/i18n.module';
import {SharedModule} from './shared/shared.module';
import {LayoutModule} from './layout/layout.module';
import {ViewsModule} from './views/views.module';
import {AuthI18n, AuthModule, AuthService} from 'auth-commons';
import {I18NService} from './i18n/i18n.service';
import {Moment} from 'moment-timezone';
import {I18NDatePipe} from './i18n/i18n.pipe';
import {CURRENT_VIEW_TOKEN, CurrentView, ViewData} from './view';
import {EMSScopeGuard} from './ems-scope.guard';
import {AdvancedUserGuard} from './advanced-user.guard';
import {EconomicsGuard} from './economics.guard';

function appConfigFactory() {
    return {
        ...APP_CONFIG, shared: {
            ...APP_CONFIG.shared,
            quantityColors: APP_CONFIG_QUANTITY_COLORS,
            aggregationColors: APP_CONFIG_AGGREGATION_COLORS,
            aggregationColorsConsolidation: APP_CONFIG_AGGREGATION_COLORS_CONSOLIDATED,
        }
    };
}

function currentViewFactory() {
    return {
        viewData: null // later initialized by AppComponent
    } as CurrentView<ViewData>;
}

class AuthI18nImpl implements AuthI18n {

    private readonly i18n: I18NService;
    private readonly i18nDatePipe: I18NDatePipe;

    constructor(i18n: I18NService, auth: AuthService) {
        this.i18n = i18n;
        this.i18nDatePipe = new I18NDatePipe(i18n, auth);
    }

    translate(text: string, ...args: any[]): string {
        return this.i18n.translate(text, ...args);
    }

    formatDate(value: Date | Moment | number, format?: string): string | null {
        return this.i18nDatePipe.transform(value, format);
    }
}

function authI18nFactory(i18n: I18NService, auth: AuthService) {
    return () => {
        auth.authI18n = new AuthI18nImpl(i18n, auth);
    };
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        // angular
        BrowserModule,
        BrowserAnimationsModule,
        // 3rd party
        ToasterModule.forRoot(),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDwa3xMngKKvsBhhptjpEueE8OrS_Tx-cE',
            libraries: ['places']
        }),
        NgApexchartsModule,
        // app modules
        CommonsModule.forRoot(APP_CONFIG.commons),
        ApiModule.forRoot(APP_CONFIG.api),
        I18nModule.forRoot(APP_CONFIG.i18n),
        AuthModule.forRoot(APP_CONFIG.auth),
        SharedModule.forRoot(APP_CONFIG.shared),
        LayoutModule.forRoot(),
        ViewsModule.forRoot(),
        // app routing
        AppRoutingModule
    ],
    providers: [
        [EMSScopeGuard, AdvancedUserGuard, EconomicsGuard],
        {provide: APP_CONFIG_TOKEN, useFactory: appConfigFactory},
        {provide: CURRENT_VIEW_TOKEN, useFactory: currentViewFactory},
        {provide: APP_INITIALIZER, useFactory: authI18nFactory, deps: [I18NService, AuthService], multi: true}
        // {provide: LocationStrategy, useClass: HashLocationStrategy}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
